/* src/locations/cards/AddLocationCard/styles.js */

export default theme => {
  const { unit } = theme.spacing;
  const space = unit * 3;
  return {
    card: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      width: unit * 100,
      transform: 'translate(-50%, -50%)',
      overflow: 'auto',
    },
    icon: {
      marginRight: unit,
    },
    button: {
      marginLeft: 'auto',
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      padding: space,
    },
    textFieldContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: unit,
    },
    formControl: {
      marginTop: unit,
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
    },
    message: {
      margin: unit * 1.5,
    },
  };
};



// WEBPACK FOOTER //
// ./src/modules/locations/cards/AddLocationCard/styles.js